import { styled } from '@linaria/react';
import { layout, radius, semantic, size, space } from '../../theme/tokens';

export const Card = styled.div`
  background: ${semantic.bg.canvas};
  border: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  border-radius: ${radius('card', 'radius-md')};
  padding: ${space['space-600']};
  box-sizing: border-box;

  &[data-size='compact'] {
    border-radius: ${radius('card', 'radius-lg')};
    padding: ${space['space-600']} ${space['space-500']};

    @media (min-width: ${layout.desktopBreakpoint}) {
      border-radius: ${radius('card', 'radius-xl')};
      padding: ${space['space-900']} ${space['space-800']} ${space['space-1200']};
    }
  }

  &[data-size='large'] {
    border-radius: ${radius('card', 'radius-xl')};
    padding: ${space['space-1000']} ${space['space-500']};

    @media (min-width: ${layout.desktopBreakpoint}) {
      padding: ${space['space-1200']} ${space['space-800']};
    }
  }
`;
